import selected from './selected/reducer';
import validate from './validate/reducer';
const { combineReducers } = require("redux");

export default combineReducers({
    selected,
    validate,
});